import { mutator } from 'satcheljs';
import { internalCloseSxS } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import getOrCreateSxSStoreData from '../store/Store';
import { findTabIdBySxSId } from 'owa-tab-store';
import getTabById from 'owa-tab-store/lib/utils/getTabById';
import closeTab from 'owa-tab-store/lib/actions/closeTab';

mutator(showSxS, actionMessage => {
    const { sxsId } = actionMessage;
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (!sxsStore.shouldShow) {
        sxsStore.shouldShow = true;
        sxsStore.sessionStartTime = new Date().getTime();
    }

    sxsStore.sessionPreviewCount++;
});

mutator(internalCloseSxS, actionMessage => {
    const { sxsId, shouldCloseWindow } = actionMessage;
    const tabId = findTabIdBySxSId(sxsId);
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    sxsStore.shouldShow = false;
    sxsStore.sessionPreviewCount = 0;

    // close the window by closing its associated tab since the tab is no longer used
    if (shouldCloseWindow) {
        const tabViewState = getTabById(tabId);
        closeTab(tabViewState);
    }
});
